import { useEffect, useRef } from "react";

// Event bus leggero: aggiornamenti istantanei nella stessa sessione
// (es. l'admin segna il negozio chiuso -> il footer cambia subito, senza reload)
export const liveEmit = (event, detail) => window.dispatchEvent(new CustomEvent(event, { detail }));

export const useLiveEvent = (event, handler) => {
  const ref = useRef(handler);
  ref.current = handler;
  useEffect(() => {
    const cb = (e) => ref.current(e.detail);
    window.addEventListener(event, cb);
    return () => window.removeEventListener(event, cb);
  }, [event]);
};

// Auto-refresh: ricarica i dati a intervalli regolari, al ritorno sulla scheda
// e al focus della finestra. Così ogni modifica fatta (da admin o altri clienti)
// diventa visibile senza ricaricare la pagina.
export const useAutoRefresh = (callback, intervalMs = 60000) => {
  const ref = useRef(callback);
  ref.current = callback;
  useEffect(() => {
    const tick = () => ref.current();
    const onVisible = () => { if (document.visibilityState === "visible") tick(); };
    const id = setInterval(tick, intervalMs);
    document.addEventListener("visibilitychange", onVisible);
    window.addEventListener("focus", tick);
    return () => {
      clearInterval(id);
      document.removeEventListener("visibilitychange", onVisible);
      window.removeEventListener("focus", tick);
    };
  }, [intervalMs]);
};
